import axiosConfig from "./axiosConfig";

// Service pour gérer les requêtes API des actualités
const ActualityService = {
  // Récupérer toutes les actualités
  getAllActualities: async () => {
    try {
      const response = await axiosConfig.get("/actualities");
      return response.data;
    } catch (error) {
      console.error("Erreur API getAllActualities:", error);
      throw error;
    }
  },

  // Créer une nouvelle actualité
  createActuality: async (actualityData) => {
    try {
      const formData = new FormData();

      formData.append("author", actualityData.author);
      formData.append("date", actualityData.date);
      formData.append("title", actualityData.title);
      formData.append("tags", actualityData.tags); // String séparée par virgules
      formData.append("content", actualityData.content);
      formData.append("type", actualityData.type);
      formData.append("description", actualityData.description);
      formData.append("category", actualityData.category);

      if (actualityData.image) {
        formData.append("image", actualityData.image);
      }

      const response = await axiosConfig.post("/actualities", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      return response.data;
    } catch (error) {
      console.error("Erreur API createActuality:", error);
      throw error;
    }
  },

  // Récupérer une actualité par ID
  getActualityById: async (id) => {
    try {
      const response = await axiosConfig.get(`/actualities/${id}`);
      return response.data;
    } catch (error) {
      console.error("Erreur API getActualityById:", error);
      throw error;
    }
  },

  // Mettre à jour une actualité
  updateActuality: async (id, actualityData) => {
    try {
      const formData = new FormData();

      formData.append("author", actualityData.author);
      formData.append("date", actualityData.date);
      formData.append("title", actualityData.title);
      formData.append("tags", actualityData.tags); // String séparée par virgules
      formData.append("content", actualityData.content);
      formData.append("type", actualityData.type);
      formData.append("description", actualityData.description);
      formData.append("category", actualityData.category);

      if (actualityData.image) {
        formData.append("image", actualityData.image);
      }

      const response = await axiosConfig.put(`/actualities/${id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      return response.data;
    } catch (error) {
      console.error("Erreur API updateActuality:", error);
      throw error;
    }
  },

  // Supprimer une actualité
  deleteActuality: async (id) => {
    try {
      await axiosConfig.delete(`/actualities/${id}`);
      return true;
    } catch (error) {
      console.error("Erreur API deleteActuality:", error);
      throw error;
    }
  },
};

export { ActualityService };
